import pageMixin from "../mixins/page";
import Axios from "axios";
export default {
  name: "product-detail-list",
  mixins: [pageMixin],
  data: function data() {
    return {
      columns: [{
        title: "商品名称",
        sortable: true,
        key: "commodity_name"
      }, {
        title: "类型",
        key: "category",
        sortable: true
      }, {
        title: "产品介质",
        key: "media_type",
        sortable: true
      }, {
        title: "软件版本",
        key: "software_version",
        sortable: true
      }, {
        title: "商品语言",
        key: "language",
        sortable: true
      }, {
        title: "产品类型标识",
        sortable: true,
        render: function render(h, params) {
          return h('span', params.row.activate_param.product_type);
        }
      }, {
        title: "激活接口",
        sortable: true,
        render: function render(h, params) {
          return h('span', params.row.activate_param.license_interface);
        }
      }],
      data: []
    };
  },
  created: function created() {
    this.refresh();
  },
  methods: {
    refresh: function refresh() {
      var _this = this;
      var onFinish = this.setLoading.bind(this, false);
      this.setLoading(true);
      Axios.get("/pmv5/service/fenxiang/product-details/", {
        params: {
          page: this.currentPage,
          per_page: this.pageSize
        }
      }).then(function (resp) {
        _this.data = resp.data.productdetails;
        _this.total = resp.data.page_info.count;
      }).then(onFinish, onFinish);
    }
  }
};